export default {
  fontFamilyDefault: 'HelveticaNeue, Helvetica, sans-serif',
};
